import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import pol from './modules/pol'
import hotPort from './modules/hotPort'
import fcl from './modules/fcl'
import booking from './modules/booking'
import city from './modules/city'
import consign from './modules/consign'
import sys from './modules/sys'
Vue.use(Vuex)

export default new Vuex.Store({
  // strict: process.env.NODE_ENV !== 'production', // 在非生产环境下，使用严格模式
  modules: {
    user,
    pol,
    fcl,
    hotPort,
    booking,
    city,
    consign,
    sys,
  },
})
